module.exports = __webpack_public_path__ + "img/video_file_upload.1d17884c.svg";